import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

export function AuthScreen({
  children,
  id,
  hidden = false,
  busy = false,
}: {
  children: ReactNode;
  id?: string;
  hidden?: boolean;
  busy?: boolean;
}) {
  return (
    <div
      id={id}
      className={cn(
        "fixed inset-0 z-20 grid place-items-center overflow-y-auto bg-background/95 p-5",
        hidden && "hidden",
      )}
    >
      <section
        aria-busy={busy}
        className="w-full max-w-md rounded-xl border border-border bg-card p-8 shadow-2xl"
      >
        {children}
      </section>
    </div>
  );
}
